/**
 * @flow
 * */

export const formMode = {
  default: 'DEFAULT',
  indianDefault: 'INDIAN_DEFAULT',
  indianEmployee: 'INDIAN_EMPLOYEE',
  indianBusiness: 'INDIAN_BUSINESS',
  otherCountryEmployee: 'OTHER_COUNTRY_EMPLOYEE',
  otherCountryBusiness: 'OTHER_COUNTRY_BUSINESS'
}

export const BUSINESS = /business/i

export const EMPLOYEE = /employee/i



// WEBPACK FOOTER //
// ./src/constants/ApplyForFranchiseConstants.js